// @flow

import React from 'react';
import classNames from 'classnames';

import {TableSize} from './constants';

import './data-table.styl';

import type {Node, StatelessFunctionalComponent as FC} from 'react';

const DATA_TABLE_SIZE_CLASSES = {
    [TableSize.M]: 'data-table__table_size-m',
    [TableSize.DEFAULT]: null
};

type Props = {|
    id: string,
    width?: number,
    children: Node,
    tableSize?: $Keys<typeof TableSize>,
    mix?: string,
    border?: boolean,
|};

export const Table: FC<Props> = ({id, mix = '', width, children, tableSize = TableSize.DEFAULT, border}: Props) => {
    const classes = classNames(
        'data-table__table',
        DATA_TABLE_SIZE_CLASSES[tableSize],
        mix,
        {
            'data-table__table_simple': !width || width === 0,
            'data-table__table_border': border,
        },
    );

    const style = width ? {'--table-width': `${width}px`} : null;

    return (
        <div
            id={id}
            style={style}
            className={classes}>
            {children}
        </div>
    );
};


            // @pb/generate-flow-typed Webpack Loader:
            // Duplicates all internal dependencies imports
            // to be sure all deps are parsed by this loader
            // cause Babel loader removes `import type ...`
            // and e.g. 'typedef.js' files are not included in dist
            
require("./constants");
